module.exports = __webpack_public_path__ + "static/media/23.2f1b2d1b.jpg";